import userTypes from 'constants/userTypes';

const getUserPermissions = (user = {}) => {
  const accessRoles = user.AccessRoles || [];
  const permissionSet = new Set();

  for (const accessRole of accessRoles) {
    let permissions = [];
    try {
      permissions = Array.isArray(accessRole.permissions) ? [...accessRole.permissions] : JSON.parse(accessRole.permissions);
    } catch {
      permissions = [];
    }
    for (const permission of permissions) {
      permissionSet.add(permission);
    }
  }
  return Array.from(permissionSet);
};

const userHasPermission = ({
  userData = {},
  validPermissionsAdmin = [],
  validPermissionsManager = [],
  validPermissionsExternalUser = []
}) => {
  let hasPermission = true;
  let validPermissions = [];

  if (userData.type === userTypes.Admin) {
    validPermissions = validPermissionsAdmin;
  } else if (userData.type === userTypes.Manager) {
    validPermissions = validPermissionsManager;
  } else if (userData.type === userTypes.ExternalUser) {
    validPermissions = validPermissionsExternalUser;
  }

  if (validPermissions.length > 0) {
    hasPermission = false;
    // get user permissions
    const userPermissions = getUserPermissions(userData);

    for (const permission of validPermissions) {
      if (userPermissions.includes(permission)) {
        hasPermission = true;
        break;
      }
    }
  }

  return hasPermission;
};

export { userHasPermission };
